import styled from 'styled-components';
import { palette } from '../../../theme/colors';
import { toRem } from '../../../utils/toRem';
import { Button } from '../../Button/Button';

export const STitle = styled.p`
  font-family: 'Roboto-Medium';
  font-size: 1.5rem;
  line-height: 2rem;
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;
  text-align: center;
`;

export const SDescriptionText = styled.span`
  font-family: 'Roboto-Regular';
  font-size: 1rem;
  line-height: 1.3rem;
  text-align: center;
  color: ${palette.ashGray};
  &.secondsCount,
  &.seconds {
    color: ${palette.white};
  }
  &.secondsCount {
    font-family: 'Roboto-Bold';
  }
`;

export const SButtonContainer = styled.div`
  .test-alarm-btn {
    margin-bottom: 30px;
  }
`;
export const SStepsContainer = styled.div`
  margin-left: 0.5rem;
  margin-right: 1.5rem;
  margin-top: 1.75rem;
`;
export const SStepContainer = styled.div`
  display: flex;
  align-items: flex-start;
  border-left: 1px dashed ${palette.queenBlue};

  &.last-step {
    margin-bottom: 0;
    border-left: none;
  }
`;
export const SStepCircle = styled.div`
  height: ${toRem(12)};
  width: ${toRem(12)};
  border-radius: ${toRem(6)};
  border: 2px solid ${palette.white};
  background-color: ${palette.ashGray};
  margin-left: ${toRem(-6.5)};
  margin-right: ${toRem(18)};
`;
export const SStepContentContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-bottom: ${toRem(24)};
`;
export const SStepNumber = styled.p`
  font-size: ${toRem(14)};
  line-height: ${toRem(17)};
  color: ${palette.ashGray};
  margin-bottom: ${toRem(4)};
`;
export const SStepText = styled.p`
  font-size: ${toRem(16)};
  line-height: ${toRem(20)};
  color: ${palette.white};
`;
export const SFullScreenContainer = styled.div`
  height: 100%;
  padding: 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const SActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
  margin-top: ${toRem(36)};
`;
export const SApproveButton = styled(Button)`
  button {
    background-color: ${palette.deepSea};
    color: ${palette.white};
  }
`;
export const SDeclineButton = styled(Button)`
  button {
    background-color: ${palette.danger};
    color: ${palette.white};
  }
`;
export const HomeButton = styled(Button)`
  button {
    background-color: ${palette.transparent};
    color: ${palette.white};
  }
`;
